import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['../../../style/global.css', './login.component.css'],
  selector: 'app-register-login',
})
export class LoginComponent {
  @Output() navigate = new EventEmitter<void>();

  doNavigate() {
    this.navigate.emit();
  }
}
